import styled from 'styled-components';

export const VideoResourcesCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const VideoPlaceholder = styled.div`
  width: 100%;
  height: 160px;
  background: ${({ theme }) => theme.colors.backgroundSecondaryGrey05};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  font-size: 14px;
  font-weight: 400;
`;

export const ViewResourcesLink = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.buttonButtonPrimarySecondary2100};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  line-height: 24px;
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
